import Vue from "vue";
import Video from "./Video.vue";

Vue.component("VideoScreen", Video);

export{};